import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayeeQuery } from "../../../query/payee/queries/usePayeeQuery";
import { getPayeeName } from "../../Payees/selectors/getPayeeNames";

type Props = {
  payeeId: string;
};

export const LablePayeeName: React.FC<Props> = props => {
  const payeeQuery = usePayeeQuery(props.payeeId);

  const name = useMemo(() => {
    if (!payeeQuery.data) {
      return;
    }

    return getPayeeName(payeeQuery.data);
  }, [payeeQuery.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox gap="XS" wrap="nowrap" alignItems="center">
      <WSIcon name="user" color="gray600" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
